define('controllers/emailcampaign',['require','johngrid'],function (require) {
    var CreateJohnGrid = require('johngrid');
    return function() {
        var msg = $("#msg"),
            peopleCount = $("#peopleCount");

        //grid..
        var grid = CreateJohnGrid(),
            AJAXUrl = "CampaignAJAX.aspx",
            columns = [{ DataField: "Skip", HeaderText: "Skip <input type='checkbox' id='chkSkipAll' />", AllowSorting: false },
                        { DataField: "ID" },
                        { DataField: "Email" },
                        { DataField: "FirstName" },
                        { DataField: "LastName" },
                        { DataField: "Employer" },
                        { DataField: "Status" },
                        { DataField: "CreateDate" }
            ];

        //            grid.sorting.allowSorting = true;
        grid.sorting.allowSorting = true;
        grid.dsPostValues.sortClause = "CreateDate DESC";
        grid.init($("#tblUsers"), columns, AJAXUrl);
        $(".johnGridHeader", grid.$table).prepend($("#usersHeader"));
        grid.onDataBinding = function () {
            grid.dsPostValues.userGroups = getUserGroups();
            grid.dsPostValues.EMailID = $("#ddlTemplates").val();
        };
        grid.onDataBound = function () {
            peopleCount.text(grid.currentDataSource.length);

            $("input[type='checkbox'].skip", grid.$table).off("click").on("click", function () {
                var currentCount = parseInt(peopleCount.text()),
                    newCount = $(this).is(":checked") ? currentCount - 1 : currentCount + 1;
                peopleCount.text(newCount);
            });
        };
        $("#chkSkipAll").on("change", function () {
            var checked = $(this).is(":checked"),
                boxes = $("input[type='checkbox'].skip", grid.$table);

            checked ? boxes.prop('checked', true) : boxes.prop('checked', false);
        });
        //end grid...

        function getUserGroups() {
            var userGroups = [];
            $("input[name='userGroups']:checked").each(function () {
                userGroups.push($(this).val());
            });
            return userGroups.join(",");
        }

        $("#btnCreateCampaign").on("click", function () {
            var data = {
                method: "CreateCampaign",
                userGroups: getUserGroups(),
                name: $("#txtCampaignName").val().trim(),
                extraPeople: $("#txtPeople").val(),
                EMailID: $("#ddlTemplates").val(),
                skipping: GetSkips()
            },
                errors = validate(data);

            //add grid.dsPostValues to data (for(var property in grid.dsPostValues) { ..add new property to data }
            //console.log(data);

            if (errors.length == 0) {
                var $this = $(this),
                    loading = $this.next();

                $this.hide();
                loading.show();
                msg.hide();
                $.post(AJAXUrl, data, function (response) {
                    Utilities.handleAJAXResponse(response, createdCampaign, handleError);
                }).complete(function () {
                    $this.show();
                    loading.hide();
                });
            } else {
                handleError(errors.join("<br />"));
            }
        });
        function validate(data) {
            var errors = [];
            if (data.name == "") {
                errors.push("Please enter campaign name.");
            }
            return errors;
        }
        function GetSkips() {
            var skips = [];
            $("input[type='checkbox'].skip:checked", grid.$table).each(function () {
                var itemIndex = $(this).parent().parent().attr("data-itemindex"),
                    email = grid.currentDataSource[itemIndex].Email;
                skips.push(email);
            });
            return skips.join(",");
        }
        function handleError(error) {
            Utilities.setError(error, msg);
        }
        function createdCampaign(obj) {
            var message = "Successfully Executed your campaign. A total of {0} emails were sent.".format(obj.emailCount);
            if (obj.fails.length > 0) {
                var failTemplate = "<br />The following {0} emails didn't get sent the message, though:<br />{1}";
                message += failTemplate.format(obj.fails.length, obj.fails.join("<br />"));
            }
            Utilities.setInfo(message, msg);
            $("#campaignContainer").hide();
        }

        $("#txtCampaignName").focus();

        //            $("#txtCampaignName").on("change", function () {
        //                //check if campaign name exists...
        //            });

        //            //update querystring thing
        //            $("#campaignName").text(campaignID);

    };
});

